import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import logoWhite from "../../assets/images/LUMA-WHITE.png";
import {
  Nav,
  Logo,
  NavLinks,
  NavLink,
  CtaButton,
  HamburgerBtn,
  MobileMenu,
  MobileNavLink,
  CloseBtn,
} from "./styles/Navbar.styles";

const NAV_LINKS = [
  { label: "Yachts", to: "/yachts" },
  { label: "Brands", to: "/brands" },
  { label: "New Buildings", to: "/new-buildings" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <>
      <Nav $scrolled={scrolled}>
        <Logo to="/">
          <img src={logoWhite} alt="LUMA Yachting" />
        </Logo>

        <NavLinks>
          {NAV_LINKS.map(({ label, to }) => (
            <li key={to}>
              <NavLink to={to} $active={location.pathname.startsWith(to)}>
                {label}
              </NavLink>
            </li>
          ))}
        </NavLinks>

        <CtaButton to="/contact">Request a Quote</CtaButton>

        <HamburgerBtn
          onClick={() => setMobileOpen(true)}
          aria-label="Open menu"
        >
          <span />
          <span />
          <span />
        </HamburgerBtn>
      </Nav>

      <AnimatePresence>
        {mobileOpen && (
          <MobileMenu
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <CloseBtn onClick={() => setMobileOpen(false)} aria-label="Close menu">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </CloseBtn>
            {NAV_LINKS.map(({ label, to }) => (
              <MobileNavLink
                key={to}
                to={to}
                $active={location.pathname.startsWith(to)}
                onClick={() => setMobileOpen(false)}
              >
                {label}
              </MobileNavLink>
            ))}
          </MobileMenu>
        )}
      </AnimatePresence>
    </>
  );
}

export default Navbar;
